import React from 'react'
import { View, StyleSheet } from 'react-native'
import DefaultContainer from './DefaultContainer'
import DefaultText from './DefaultText'
import DefaultButton from './DefaultButton'
//import bg from './images/bg.jpg'
import { warningColor } from './_variables.scss'

const KokosilClientError = () => (
  <View style={styles.bg}>
    <DefaultContainer style={styles.container}>
      <DefaultText>ココシルアプリとの連携に問題が発生しました。</DefaultText>
    </DefaultContainer>
    <DefaultButton
      title="再読み込み"
      color={warningColor}
      onPress={() => window.location.reload()}
    />
  </View>
)

const styles = StyleSheet.create({
  bg: {
    minHeight: '100vh',
//    backgroundImage: `url(${bg})`,
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    width: '80%',
  },
})

export default KokosilClientError
